import { render, staticRenderFns } from "./WebOrders.vue?vue&type=template&id=4d8dbc32&"
import script from "./WebOrders.vue?vue&type=script&lang=js&"
export * from "./WebOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports